import { FAILURE, REQUEST, SUCCESS } from 'src/redux/constants';
import { CURRENT_USERS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { CurrentUsersDataActionTypes } from './types';
import userApi from 'src/utils/api/userApi';
import { LocalStorageKeysEnum, RoleEnum } from 'src/utils/enum';

export const loadCurrentUsers =
  (): ThunkAction<Promise<void>, State, null, CurrentUsersDataActionTypes> =>
  async (dispatch) => {
    dispatch({ type: CURRENT_USERS + REQUEST });
    try {
      const payload = await userApi.loadCurrentUsers();
      if (payload.role_name.includes(RoleEnum.ADMIN)) {
        localStorage.setItem(LocalStorageKeysEnum.ROLE, RoleEnum.ADMIN);
      } else if (payload.role_name.includes(RoleEnum.MODERATOR)) {
        localStorage.setItem(LocalStorageKeysEnum.ROLE, RoleEnum.MODERATOR);
      } else if (payload.role_name.includes(RoleEnum.SECURITY)) {
        localStorage.setItem(LocalStorageKeysEnum.ROLE, RoleEnum.SECURITY);
      } else {
        localStorage.setItem(LocalStorageKeysEnum.ROLE, RoleEnum.USER);
      }
      dispatch({ type: CURRENT_USERS + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: CURRENT_USERS + FAILURE, error });
    }
  };
